"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_tablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "63485fb1-50da-49f5-a399-1e190b1ca4a9",
    "data-name": "Sim_ic_hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 191.92 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "61b8a6f1-110b-485e-a690-9e608bd435f0",
    x1: 35.8,
    y1: 34.34,
    x2: 156.12,
    y2: 154.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "tablet-hi"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 16,
    width: 112,
    height: 160,
    rx: 8,
    ry: 8,
    transform: "translate(191.96 0) rotate(90)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.96,
    y: 49,
    width: 152,
    height: 91,
    rx: 2,
    ry: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.96,
    y: 44,
    width: 16,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.96,
    y: 44,
    width: 2,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.96,
    y: 143,
    width: 12,
    height: 4,
    rx: 2,
    ry: 2,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,150H24a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8v-2A8,8,0,0,1,168,150Z",
    transform: "translate(-0.04 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "01e3ef20-96cd-4c09-a54f-5b3dbaef09e0",
    "data-name": "Bounding Box",
    y: 0.04,
    width: 192,
    height: 191.92,
    transform: "translate(191.96 0) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.96,
    y: 49,
    width: 152,
    height: 91,
    rx: 2,
    ry: 2,
    opacity: 0.5,
    fill: "url(#61b8a6f1-110b-485e-a690-9e608bd435f0)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170,50a1,1,0,0,1,1,1v87a1,1,0,0,1-1,1H22a1,1,0,0,1-1-1V51a1,1,0,0,1,1-1H170m0-1H22a2,2,0,0,0-2,2v87a2,2,0,0,0,2,2H170a2,2,0,0,0,2-2V51a2,2,0,0,0-2-2Z",
    transform: "translate(-0.04 0)",
    fill: "#333"
  })));
}

var _default = ic_tablet;
exports.default = _default;